import { ChangeLog, Response, apiAbortController } from '@ui/src';
import api from '../../../../../../api/api';
import { RateRequest, RateRequestFormValues } from '../types';

export const rateRequestApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRateRequest: build.query<Response<RateRequest>, string>({
      query: (query) => ({
        url: `/v1/exchange-custom-rate-rules${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getRateRequestDefault: build.query<{ data: RateRequest }, void>({
      query: () => ({
        url: '/v1/exchange-custom-rate-rules/default',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getRateRequestItem: build.query<{ data: RateRequest }, string>({
      query: (id) => ({
        url: `/v1/exchange-custom-rate-rules/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    createRateRequestPair: build.mutation<
      {
        data: RateRequest;
      },
      RateRequestFormValues
    >({
      query: (data) => ({
        url: '/v1/exchange-custom-rate-rules',
        method: 'POST',
        body: data,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    updateRateRequestsPair: build.mutation<
      {
        data: RateRequest;
      },
      { body: RateRequestFormValues; id: string }
    >({
      query: (data) => ({
        url: `/v1/exchange-custom-rate-rules/${data.id}`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    changeRateRequestStatus: build.mutation<
      {
        data: RateRequest;
      },
      { active: boolean; id: string }
    >({
      query: (data) => ({
        url: `/v1/exchange-custom-rate-rules/${data.id}/status`,
        method: 'PUT',
        body: {
          active: data.active,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getRateRequestChangeLogs: build.query<Response<ChangeLog>, string>({
      query: (query) => ({
        url: `/v1/audit-log${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetRateRequestDefaultQuery,
  useLazyGetRateRequestItemQuery,
  useLazyGetRateRequestQuery,
  useCreateRateRequestPairMutation,
  useUpdateRateRequestsPairMutation,
  useChangeRateRequestStatusMutation,
  useLazyGetRateRequestChangeLogsQuery,
} = rateRequestApi;

export const {
  endpoints: {
    getRateRequest,
    getRateRequestDefault,
    getRateRequestItem,
    createRateRequestPair,
    updateRateRequestsPair,
    changeRateRequestStatus,
    getRateRequestChangeLogs,
  },
} = rateRequestApi;
